module.exports = __webpack_public_path__ + "static/notifications-9cd8a6a9260796223dfb7f00b6defa60.svg";